import { render, staticRenderFns } from "./vue_jqxsplitter.vue?vue&type=template&id=79bee5f4"
import script from "./vue_jqxsplitter.vue?vue&type=script&lang=js"
export * from "./vue_jqxsplitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports